<div
  @transformOpacityScale
  class="absolute z-10 bg-white rounded-md shadow-lg right-5 text-text-primary min-w-32 ring-1 ring-black/5 focus:outline-hidden"
  role="menu"
  tabindex="-1"
  dropdownPosition
>
  <div class="py-1">
    @for (item of items(); track item) {
      <button
        class="block w-full px-4 py-2 text-sm text-left whitespace-nowrap hover:cursor-pointer hover:bg-background-1"
        role="menuitem"
        (click)="clickOption(item); $event.stopPropagation()"
      >
        {{ item.label }}
      </button>
    }
  </div>
</div>
